import { useState, useRef } from 'react';

export function useCarouselNavigation({ imageIds, displayCount }) {
  const [showCount, setShowCount] = useState(displayCount);
  const listRef = useRef(null);

  const getListElement = () => {
    if (!listRef.current) return null;
    return listRef.current;
  };

  const moveScroll = (numberOfPixels, isNext) => {
    const listElement = getListElement();
    if (!listElement) return;

    const totalDistance = listElement.scrollLeft + numberOfPixels;
    const { scrollLeft, offsetWidth, scrollWidth } = listElement;
    if (isNext && offsetWidth + scrollLeft >= scrollWidth) return;

    const leftPosition = totalDistance < 0 ? 0 : Math.max(-scrollLeft, totalDistance);

    listElement.scrollTo({
      top: 0,
      left: leftPosition,
      behavior: 'smooth'
    });
  };

  const handleNavigation = direction => {
    setShowCount(false);

    const listElement = getListElement();
    if (!listElement) return;

    const { scrollWidth } = listElement;
    const offset = scrollWidth / imageIds.length;

    direction ? moveScroll(offset, direction) : moveScroll(-offset, direction);
  };

  return {
    listRef,
    showCount,
    handleNavigation,
    direction: {
      next: true,
      back: false
    }
  };
}
